import Insight from "../insightClass";
import React from "react";
import { insight29Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight055 = new Insight(
  "18 July 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight29Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-07-18)",
  "",
  `The UK government has extended Contracts for Difference (CfD) from 15 to 20 years, improving long-term revenue stability for offshore wind projects. The move aims to restore investor confidence ahead of Allocation Round 6 in August, following a disappointing Round 5.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-07-18)</h1>
    <h2></h2>
    <p className="article-date">18 July 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. UK Extends CfD Term from 15 to 20 Years</h3>
    <p>
      The UK government has extended Contracts for Difference (CfD) from 15 to
      20 years, improving long-term revenue stability for offshore wind
      projects. The move aims to restore investor confidence ahead of Allocation
      Round 6 in August, following a disappointing Round 5.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This change significantly improves project bankability, reduces the
      levelized cost of energy (LCOE), and could unlock new financing for
      large-scale projects. However, its fiscal impact on future energy bills
      must be closely monitored.
    </p>
    <h3>2. UK Completes Dogger Bank South Examination</h3>
    <p>
      The UK Planning Inspectorate has concluded its six-month examination of
      the 3 GW Dogger Bank South offshore wind project. The development consent
      recommendation will be submitted by October, marking a key step in
      advancing one of the world’s largest wind power initiatives.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This milestone advances a strategic North Sea cluster and de-risks one of
      the UK’s most ambitious energy projects. Timely planning decisions will be
      crucial to meeting 2030 delivery timelines and avoiding bottlenecks in
      grid integration and supply chain mobilisation.
    </p>
    <h3>3. Masdar and Iberdrola Invest in East Anglia THREE</h3>
    <p>
      UAE’s Masdar and Spain’s Iberdrola announced a €5.2 billion investment in
      the UK’s 1.4 GW East Anglia THREE offshore wind farm, set to be
      operational by 2026. This strengthens international collaboration in UK
      renewable energy.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This cross-border partnership highlights sustained international interest
      in UK offshore wind despite policy uncertainties. It may serve as a
      benchmark for future public-private co-investment models.
    </p>
    <h3>4. Japanese firm selected for 85 mile UK subsea cable</h3>
    <p>
      National Grid has selected Sumitomo Electric as the preferred bidder for
      the Sea Link project—an 85 mile, 525 kV HVDC cable connecting Kent to
      Suffolk. Manufactured at its Port of Nigg facility, the link boosts
      Britain’s Great Grid Upgrade initiative, increasing transmission capacity,
      jobs, and domestic supply chain resilience.{" "}
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Sumitomo’s selection reflects the UK’s focus on proven HVDC expertise and
      domestic supply chain growth. Manufacturing at Port of Nigg supports
      reindustrialisation goals, while Sea Link is critical to integrating
      post-AR7 offshore wind. Success will depend on aligning cable delivery
      with project timelines and ensuring grid capacity is pre-allocated to
      avoid bottlenecks.
    </p>
    <h3>5. Netherlands Reduces Offshore Wind Target</h3>
    <p>
      The Dutch government has revised its 2040 offshore wind target from 50 GW
      down to 30–40 GW and delayed upcoming tenders, citing concerns over
      ecological impact, grid capacity, and economic feasibility.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This recalibration reflects rising tension between ambition and
      practicality. Environmental constraints and power demand uncertainties are
      reshaping planning. The reduction could affect long-term investor
      confidence but may improve short-term implementation realism and
      stakeholder alignment.
    </p>
    <h3>6. China Unveils Large-Scale Floating Wind Prototype</h3>
    <p>
      A leading Chinese energy group has revealed a new high-capacity floating
      wind prototype, signalling China’s commitment to entering deeper waters
      and competing in global floating wind technology development.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      China is rapidly closing the innovation gap in floating wind. This
      development could challenge European technology dominance and reshuffle
      the global supply chain hierarchy.
    </p>
    <h3>7. Saudi Arabia Commits $8.5 Billion to Renewables</h3>
    <p>
      A consortium led by ACWA Power will invest $8.5 billion in Saudi Arabia to
      develop 15 GW of renewable energy capacity, including both wind and solar.
      This marks a substantial step in the kingdom’s push to diversify its
      energy mix.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      While utility-scale wind development in Saudi Arabia remains nascent, this
      announcement signals strong political and financial backing for
      renewables. If offshore wind is included in future phases, it could
      catalyse a new frontier for supply chain localisation in the Middle East.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
